// extracted by mini-css-extract-plugin
export default {"topicDescription":"topic-description_topicDescription__fUSV9"};